module.exports = __webpack_public_path__ + "media/images/landing/client_WGNAmerica-50976ad4fd7e1afd52d2b92eba9f873a.png";